import type { FC } from 'react';
import { useEffect } from 'react';

export const focusOutlineVisibilityClassName = 'lokalise-ui_focus_outline_should_be_visible';

const FocusOutlineVisibilityProvider: FC = ({ children }) => {
    useEffect(() => {
        const { body } = document;
        const keyDownHandler = (e: KeyboardEvent) => {
            if (['Tab', 'ArrowUp', 'ArrowDown'].includes(e.code)) {
                body.classList.add(focusOutlineVisibilityClassName);
            }
        };
        const mouseDownHandler = () => body.classList.remove(focusOutlineVisibilityClassName);

        document.addEventListener('mousedown', mouseDownHandler);
        document.addEventListener('keydown', keyDownHandler);

        return () => {
            document.removeEventListener('mousedown', mouseDownHandler);
            document.removeEventListener('keydown', keyDownHandler);
        };
    }, []);

    // eslint-disable-next-line react/jsx-no-useless-fragment -- since we can't be sure children is compatible with component return type, we wrap it in fragment
    return <>{children}</>;
};

export default FocusOutlineVisibilityProvider;
